import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 15 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M8.723 14.58a.7.7 0 0 0 .204-.154c3.06-.823 5.323-3.691 5.323-7.094 0-2.292-1.476-6.646-1.538-6.83A.75.75 0 0 0 12 0H2.25a.75.75 0 0 0-.712.502C1.476.686 0 5.04 0 7.332c0 3.403 2.264 6.27 5.323 7.094a.7.7 0 0 0 .204.154c.523.268.848.793.848 1.37v4.58c0 .808-.673 1.466-1.5 1.466h-1.5a.74.74 0 0 0-.75.733c0 .405.336.733.75.733h7.5c.414 0 .75-.328.75-.733a.74.74 0 0 0-.75-.733h-1.5c-.827 0-1.5-.658-1.5-1.466v-4.58c0-.577.325-1.102.848-1.37M1.5 7.332c0-1.634.916-4.67 1.298-5.865h8.655c.381 1.194 1.297 4.23 1.297 5.865 0 3.234-2.523 5.866-5.625 5.866S1.5 10.566 1.5 7.332"
    }, null, -1)
  ]))]))
}
export default { render: render }